import { render, staticRenderFns } from "./AboutTeamIndex.vue?vue&type=template&id=9ea9616e&"
import script from "./AboutTeamIndex.vue?vue&type=script&lang=js&"
export * from "./AboutTeamIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports